// extracted by mini-css-extract-plugin
export default {"cls1":"K1h8bbLAiQTnpfgOv1sD","cls2":"viYfVsjj1CQMWvAjTV4G K1h8bbLAiQTnpfgOv1sD"};